import React from 'react';
import CurrencyInput from '../CurrencyInput';

// Recebe tiposBens e naturezas como props

function BensModal({ show, onClose, onSubmit, form, handleChange, title = 'CADASTRO DE BENS' }) {
  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-boxes me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Descrição *</label>
                <input type="text" className="form-control" name="descricao" value={form.descricao} onChange={handleChange} required />
              </div>
              {/* Natureza e Tipo de Bem removidos, pois vêm da despesa */}
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Quantidade *</label>
                  <input type="number" className="form-control" name="qtde" value={form.qtde} onChange={handleChange} required min="1" />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Valor Unit. *</label>
                  <CurrencyInput className="form-control" name="vlr" value={form.vlr} onChange={handleChange} required />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Desconto</label>
                  <CurrencyInput className="form-control" name="desconto" value={form.desconto} onChange={handleChange} />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Total</label>
                  <input
                    type="text"
                    className="form-control text-end"
                    value={(((parseFloat(form.qtde) || 0) * (parseFloat(form.vlr) || 0)) - (parseFloat(form.desconto) || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    readOnly
                    disabled
                    tabIndex={-1}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

// Definir props padrão para garantir compatibilidade
BensModal.defaultProps = {
  tiposBens: [],
  naturezas: []
};

export default BensModal;
